import {FormValues} from '@wix/form-viewer'
import {
  BUYER_FORM_HEADER_ID,
  BUYER_FORM_SUBMIT_BUTTON_ID,
  RSVP_FORM_HEADER_ID,
  RSVP_FORM_SUBMIT_BUTTON_ID,
  TICKET_HOLDER_FORM_HEADER_ID,
  TICKET_HOLDER_FORM_SUBMIT_BUTTON_ID,
} from '@wix/wix-events-commons-statics'
import {TFunction} from '@wix/yoshi-flow-editor'

export const buildOverrides = (
  defaultFormValues: FormValues,
  member: boolean,
  rsvp: boolean,
  ticketed: boolean,
  useBuyerDetails: boolean,
) => {
  let overrides = {}

  if (defaultFormValues.email && member) {
    overrides = {email: {disabled: true}}
  }

  if (useBuyerDetails) {
    overrides = {
      ...overrides,
      first_name: {disabled: true},
      last_name: {disabled: true},
      email: {disabled: true},
    }
  }

  if (rsvp) {
    overrides = {
      ...overrides,
      [RSVP_FORM_HEADER_ID]: {hidden: true},
      [RSVP_FORM_SUBMIT_BUTTON_ID]: {hidden: true},
    }
  }

  if (ticketed) {
    overrides = {
      ...overrides,
      [BUYER_FORM_HEADER_ID]: {hidden: true},
      [BUYER_FORM_SUBMIT_BUTTON_ID]: {hidden: true},
      [TICKET_HOLDER_FORM_HEADER_ID]: {hidden: true},
      [TICKET_HOLDER_FORM_SUBMIT_BUTTON_ID]: {hidden: true},
    }
  }

  return overrides
}

export const getSubmitButtonText = (
  messages: wix.events.form.FormMessages,
  ticketed: boolean,
  hasPolicies: boolean,
  waitlistOpen: boolean,
  t: TFunction,
) => {
  if (ticketed) {
    return messages.checkout.submitActionLabel || messages.rsvp.submitActionLabel
  }

  if (waitlistOpen) {
    return t('detailsPage.registrationForm.waitlist.submitButtonText')
  }

  if (hasPolicies) {
    return t('mobile.checkout.next')
  }

  return messages.rsvp.submitActionLabel
}
